/**
 * AppealSlice Generation Reducers
 * 
 * Reducers for managing AI generation state and errors.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { AppealSliceState } from '../state';

// =============================================================================
// GENERATION STATE REDUCERS
// =============================================================================

/**
 * Set whether AI generation is in progress
 */
export const setGenerationInProgress: CaseReducer<AppealSliceState, PayloadAction<boolean>> = (
  state,
  action
) => {
  state.generationInProgress = action.payload;
};

/**
 * Set an error message
 */
export const setError: CaseReducer<AppealSliceState, PayloadAction<string | null>> = (
  state,
  action
) => {
  state.error = action.payload;
};

/**
 * Clear the current error
 */
export const clearError: CaseReducer<AppealSliceState> = (state) => {
  state.error = null;
};
